// Wallboard access codes are 5 capitals and digits, without look-alikes
// (functions repo: http/auth/tokens.js), and are matched exactly. Codes never
// contain lowercase letters, so capitalising what was typed can't turn a wrong
// code into a right one: it only makes "7kq4m" work for 7KQ4M. Spaces are
// dropped too (copied with a trailing space, or typed as "7KQ 4M"), and
// anything past the 5th character.
export const ACCESS_CODE_LENGTH = 5;

const normalizeAccessCode = (code: string): string =>
  code.replace(/\s+/g, '').toUpperCase().slice(0, ACCESS_CODE_LENGTH);

export default normalizeAccessCode;
